import React, { useEffect } from "react";
import { checkSecurity } from './Security';
import { useNavigate } from 'react-router-dom';

const Routing = () => {

  // CHECK SECURITY
  const navigate = useNavigate();

  useEffect(() => {
    checkSecurity(navigate);
  }, []);
  // END SECURITY

  return (
    <div></div>
  )
}

export default Routing
